import styled from '@emotion/styled'

const SkeletonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 1;
	gap: ${({ theme }) => theme.spaces.space4};
	position: relative;
	padding: ${({ theme }) => theme.spaces.space4};
`

const SkeletonCard = styled.div<{ opacity: number }>`
	padding: ${({ theme }) => theme.spaces.space6};
	background-color: ${({ theme }) => theme.colors.light.grayscale[100]};
	border-radius: ${({ theme }) => theme.borderRadiuses.xl};
	margin-bottom: ${({ theme }) => theme.spaces.space4};
	box-shadow: ${({ theme }) => theme.boxShadows.subtle};
	opacity: ${({ opacity }) => opacity};
	height: 160px;
	width: 700px;
`

function RulesFormSkeleton() {
	return (
		<SkeletonWrapper data-testid="rules-form-skeleton">
			{Array.from({ length: 4 }).map((_, index) => (
				<SkeletonCard key={index} opacity={1 - index * 0.2} />
			))}
		</SkeletonWrapper>
	)
}

export default RulesFormSkeleton
